import { useGrowthBook } from '@growthbook/growthbook-react'

interface AppFeatures {
  'liff-fp-banner-overlap': boolean
}

const useFeatureFlag = () => {
  const growthbook = useGrowthBook<AppFeatures>()

  const isFpBannerOverlapEnabled = () => growthbook.isOn('liff-fp-banner-overlap')

  return { isFpBannerOverlapEnabled }
}

export default useFeatureFlag
